import { createFileRoute } from '@tanstack/react-router';
import { ObjectAttributesEdit } from '@/pages/workspaces/objects/object-detail/object-attributes-edit';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/edit')(
  {
    component: withRumPageRendered(ObjectAttributesEdit),
  },
);
